import React, { CSSProperties } from 'react';

interface Props {
    imageUrl?: string;
    className: string;
}
export default class SidebarHeaderPreview extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { children, className, imageUrl } = this.props;

        let imageStyle: CSSProperties = {};
        if (imageUrl) {
            imageStyle.backgroundImage = `url(${imageUrl})`;
        }

        let classNames: Array<string> = ['ct-sidebar__header-preview'];
        if (className) {
            classNames.push(className);
        }

        return (
            <div className={classNames.join(' ')}>
                {imageUrl ? <div className="ct-sidebar__header-preview-image" style={imageStyle} /> : children}
            </div>
        );
    }
}
